import React from 'react';

import { useSelector } from 'react-redux';

import { Col, Image, Row } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { bestDealClick } from 'reaxl-analytics-handlers';
import { Tip } from 'reaxl-molecules';

import queryDuck from '@/ducks/queryDuck.js';

import useSrpNavigation from '@/hooks/useSrpNavigation';

const renderTipBody = (onEntryPointClick = () => {}) => (
    <div
        className="cursor-pointer text-link padding-horizontal-0"
        onClick={onEntryPointClick}
        role="link"
        tabIndex={0}
    >
        <Row className="display-flex align-items-center padding-left-2 padding-left-lg-4">
            <Col
                className="text-right text-sm-right padding-horizontal-0 padding-right-4"
                xs={1}
            >
                <Image
                    alt="KBB logo"
                    height={25}
                    src="/content/static/img/icon/logos/kbb-logo-notext.svg"
                    width={20}
                />
            </Col>
            <Col
                className="padding-left-2"
                xs={11}
            >
                <span className="display-md-none display-lg-inline">
                    Shop all the best deals
                </span>
                <span className="display-inline display-lg-none">All the best deals</span>
            </Col>
        </Row>
    </div>
);

function BestDealsFilterEntryPoint({
    className,
}) {

    const query = useSelector(queryDuck.selectors.getDuckState);
    const navigateToSrp = useSrpNavigation();

    const handleEntryPointClick = async (e) => {
        e.preventDefault();
        sendClick(bestDealClick);

        navigateToSrp({
            filtersValues: { ...query, experience: 'best-deals' },
            resetPagination: true,
        });
    };

    return (
        <div
            className={className}
            data-cmp="best-deals-srp-filter-entry-point"
        >
            <Tip
                body={renderTipBody(handleEntryPointClick)}
                className="rounded padding-horizontal-4"
                borderColor="info-200"
                backgroundColor="info-100"
            />
        </div>
    );
}

export default BestDealsFilterEntryPoint;
